<template>
  <div>
    <Card>
      <ui-label
        text="Test label"
        help-tooltip="Test help tooltip"
        :text-bold="false"
      ></ui-label>
    </Card>
    <Card>
      <ui-label
        text="Test label"
        :text-bold="true"
      ></ui-label>
    </Card>
    <Card>
      <ui-label
        :customStyle="{ textColor: $colors.green }"
        text="Test label"
        size="12"
      ></ui-label>
    </Card>
  </div>
</template>

<script setup lang="ts">
import Card from '@/stories/utils/card.vue';

import { useColors } from '@/composables';

const $colors = useColors();
</script>
